module.exports = __webpack_public_path__ + "media/images/logo_le_bon_jack-9193477d54085d8e5588895bbfdad9dc.png";